export default __webpack_public_path__ + "static/media/logo-mindgrapher-color.f70e6b44.png";